<template>
  <div class="content">
    <el-row class="content-line">
      <el-col :span="8" class="title">姓名：</el-col>
      <el-col :span="14" class="text">{{$storage.get('patient').clinic_patient_name}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">就诊卡号：</el-col>
      <el-col :span="14" class="text">{{$storage.get('patient').clinic_num?$storage.get('patient').clinic_num:'000000'}}</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">总费用：</el-col>
      <el-col :span="14" class="text">￥{{amount}}</el-col>
    </el-row>
    <div v-if="payList.length>0">
      <el-table :data="payList" style="width: 100%" border :header-cell-style="{background:'#87CEFA',color:'#fff'}">
        <el-table-column prop="项目" label="项目" width="140" align="center"></el-table-column>
        <el-table-column prop="单位" label="单位" min-width="20" align="center"></el-table-column>
        <el-table-column prop="数量" label="数量" min-width="20" align="center"></el-table-column>
        <el-table-column prop="单价" label="单价" min-width="20" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="noCard" v-if="!payList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无清单</div>
    </div>
  </div>
</template>

<script>
  import {getzyQDfeelist} from '../../api/index'
  export default {
    data(){
      return{
        amount:0,
        payList:[]
      }
    },
    created() {
      //修改标题
      document.title = '费用清单'
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      getzyQDfeelist({
        name:this.$storage.get('patient').clinic_patient_name,
        cardnum:this.$storage.get('patient').clinic_num,
        healthcardno:this.$storage.get('patient').healthCardId,
        patientid:this.$storage.get('patient').patient_id,
      }).then(res=>{
        loading.close();
        this.payList = res.Data
        if(res.Data.length>0){
          this.amount = res.Data[0].总金额
        }
      })
    }
  }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  .content-line{
    height: .8rem;
    background-color: #FFFFFF;
    margin-bottom: 1px;
  }
  .title{
    line-height: .8rem;
    margin-left: .3rem;
    color: #666666;
  }
  .text{
    line-height: .8rem;
    text-align: right;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/expensesList.vue